import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/workspace/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/workspace/layouts/default.vue").then(m => m.default || m))
}